import moment, {
  Moment, Duration, MomentInput,
} from 'moment';

// eslint-disable-next-line no-shadow
export enum DateFormatStringEnum {
  MMMDoyyyHHmm = 'MMM Do, yyy | HH:mm',
  MMMDoyyyHmma = 'MMM Do, YYYY | h:mm a',
  MMMYYYY = 'MMM YYYY',
  HHmmDDMMYYYY = 'HH:mm DD/MM/YYYY',
  DDMMYYYY = 'DD/MM/YYYY',
  DDMMYYYYhmm = 'DD/MM/YYYY h:mm',
  YYYYMMDDHHmmss = 'DD/MM/YYYY HH:mm:ss',
  YYYYMMDDHmmss = 'MMM Do, yyy HH:mm',
  DDMMYYYYhhmm = 'DD/MM/YYYY hh:mm',
  MMM = 'MMM',
  YYYY = 'YYYY',
  ISO8601 = 'YYYY-MM-DDTHH:mm:ssZ',
}

// initialize

export const initDate = (value?: MomentInput, utc?: boolean) => (utc ? moment.utc(value) : moment(value));

export const initDateFromMonthYear = (month: string, year: number): Moment => moment()
  .date(15).month(month).year(year)
  .hour(15)
  .minute(15)
  .second(15);

// getter

export const getDiff = (dateA: MomentInput, dateB: MomentInput, unitOfTime?: moment.unitOfTime.Diff, precise?: boolean): number => moment(dateA).diff(moment(dateB), unitOfTime, precise);

export const getDuration = (dateA: MomentInput, dateB: MomentInput, unitOfTime?: moment.unitOfTime.Diff, precise?: boolean): Duration => moment.duration(moment(dateA).diff(moment(dateB), unitOfTime, precise));

export const getDurationInYears = (dateA: MomentInput, dateB: MomentInput): number => getDuration(dateA, dateB).asYears();

export const getDurationInMonths = (dateA: MomentInput, dateB: MomentInput): number => getDuration(dateA, dateB).asMonths();

// formatter

export const formatDateTime = (value?: MomentInput, formatString: string | undefined = DateFormatStringEnum.DDMMYYYYhhmm, utc = false) => initDate(value, utc).format(formatString);

// methods

export const isValidDate = (date: MomentInput, format: string | undefined = DateFormatStringEnum.DDMMYYYY) => moment(date, format, true).isValid();
